"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMobile = exports.updateClientsContact = exports.setPrimary = exports.importClientsContact = exports.getClientsContacts = exports.getClientsContactCount = exports.getClientsContactById = exports.getClientsContactApprovalCount = exports.deleteClientsContact = exports.defaultClientsContactData = exports.createClientsContact = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultClientsContactData = exports.defaultClientsContactData = {
  id: 0,
  enabled: true,
  status: undefined,
  firstName: '',
  lastName: '',
  mobileNumber: null,
  emailAddress: null,
  designation: null,
  communicationPreference: null,
  department: null,
  isPrimary: false,
  clientId: null,
  client: {
    id: undefined
  },
  categorization: null,
  address: '',
  salutation: '',
  panNumber: null,
  gstNumber: null,
  gstAttachment: null
};
const getClientsContacts = params => {
  // ✅ if string → append to URL
  if (typeof params === 'string') {
    return (0, _request.default)({
      url: '/clients-contacts' + params,
      method: 'get'
    });
  }
  // ✅ if object → normal behavior
  return (0, _request.default)({
    url: '/clients-contacts',
    method: 'get',
    params
  });
};
exports.getClientsContacts = getClientsContacts;
const getClientsContactById = id => (0, _request.default)({
  url: `/clients-contacts/${id}`,
  method: 'get'
});
exports.getClientsContactById = getClientsContactById;
const updateClientsContact = (id, data) => (0, _request.default)({
  url: `/clients-contacts/${id}`,
  method: 'patch',
  data
});
exports.updateClientsContact = updateClientsContact;
const deleteClientsContact = id => (0, _request.default)({
  url: `/clients-contacts/${id}`,
  method: 'delete'
});
exports.deleteClientsContact = deleteClientsContact;
const createClientsContact = data => (0, _request.default)({
  url: '/clients-contacts/',
  method: 'post',
  data
});
exports.createClientsContact = createClientsContact;
const setPrimary = data => (0, _request.default)({
  url: '/clients-contacts/set-primary/',
  method: 'post',
  data
});
exports.setPrimary = setPrimary;
const validateMobile = data => (0, _request.default)({
  url: '/clients-contacts/validate-mobile/',
  method: 'post',
  data
});
exports.validateMobile = validateMobile;
const importClientsContact = data => (0, _request.default)({
  url: '/clients-contacts/file-import',
  method: 'post',
  data
});
exports.importClientsContact = importClientsContact;
const getClientsContactCount = data => (0, _request.default)({
  url: '/clients-contacts/count',
  method: 'post',
  data
});
exports.getClientsContactCount = getClientsContactCount;
const getClientsContactApprovalCount = () => (0, _request.default)({
  url: '/clients-contacts/approval-count',
  method: 'get'
});
exports.getClientsContactApprovalCount = getClientsContactApprovalCount;